function IncorrectLink() {
  return (
    <>
      <h1>Le lien est incorrect</h1>
      <br></br>
      <h3>Le numéro de livraison est erroné ou a déjà été confirmé/annulé</h3>
    </>
  );
}

export default IncorrectLink;
